@if (product){
    <li class="col-span-1 flex flex-col  rounded-lg bg-card  shadow">
        <div class="flex flex-1 flex-col p-8 gap-3 cursor-pointer" [routerLink]="['/marketplace/product', product._id]">
            <div class="flex  text-normal  items-center justify-center gap-2 relative">
                @if (product.bannerId){
                    <img src="{{product.bannerId.s3Url}}" loading="lazy"  alt="images" class="mx-auto size-40 rounded-xl object-cover w-auto shrink flex-1 {{product.bannerId.class}}" />
                }
            </div>
            <h3 class="mt-2 text-xl font-medium text-normal truncate">{{product.title}}</h3>
            <dl class="mt-1 flex grow flex-col justify-between">
                <dt class="sr-only">{{product.title}}</dt>
                <dd class="text-sm text-white-dark">{{'price'| translate}}` {{ costMin | currency: product.services[0]?.currency}}  {{ costMax? '-': null }} {{costMax? (costMax | currency: product.services[1]?.currency): null }}  </dd>
                @if (product.categoryId){
                    <dt class="sr-only">{{product.categoryId.name}}</dt>
                    <dd class="mt-3">
                        <span class="inline-flex items-center rounded-full bg-green-50 px-2 py-2 text-xs font-medium text-normal ring-1 ring-inset ring-primary">{{product.categoryId.name}}</span>
                    </dd>
                } @else if (product.productType){
                    <dt class="sr-only">{{product.productType}}</dt>
                    <dd class="mt-3">
                        <span class="inline-flex items-center rounded-full bg-green-50 px-2 py-2 text-xs font-medium text-normal ring-1 ring-inset ring-primary">{{product.productType}}</span>
                    </dd>
                }

            </dl>

        </div>

    </li>
}
